<section>
    <app-gjt></app-gjt>

    <div class="log-img container">
        <div class="row img">
            <img class="col" src="assets/Image/Logo/camilo.png">
        </div>
    </div>
</section>